import React from 'react'
import { connect } from 'react-redux'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import * as MASKS from '../../utils/input-masks'
import { closeDrawer } from '../../../reducers/ui-drawer'
import { callApi } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

const EditMainProfile = ({ dispatch, chef }) => {
    const submitFX = (formData, formId) => {
        dispatch(callApi(apiResourceEndpoint('chefs', 'UPDATE', chef.id), formData, formId))
    }

    const successFX = () => {
        dispatch(closeDrawer())
    }

    return (
        <div>
            <h3>Edit Profile</h3>
            <SHSForm submitFX={submitFX} successFX={successFX} resetForm={true} showCancel={true} cancelAction={() => dispatch(closeDrawer())}>
                <InputElement
                    type="text"
                    id="firstName"
                    label="First Name"
                    default={chef.firstName}
                    required />
                <InputElement
                    type="text"
                    id="lastName"
                    label="Last Name"
                    default={chef.lastName}
                    required />
                <InputElement
                    type="text"
                    id="displayName"
                    label="Preferred Name"
                    default={chef.displayName}
                    required />
                <InputElement
                    type="text"
                    id="city"
                    label="City"
                    default={chef.city} />
                <InputElement
                    type="text"
                    id="state"
                    label="State"
                    default={chef.state} />
                <InputElement
                    type="email"
                    id="email"
                    label="Email"
                    default={chef.email}
                    required />
                <InputElement
                    type="text"
                    id="phone"
                    label="Phone"
                    isFormatted={true}
                    formatMask={MASKS.phoneMask}
                    default={chef.phone}
                    required />
                <InputElement
                    type="text"
                    id="website"
                    label="Website"
                    default={chef.website} />
                <InputElement
                    type="text"
                    id="instagram"
                    label="Instagram"
                    default={chef.instagram} />
            </SHSForm>
        </div>
    )
}

export default connect()(EditMainProfile)
